import React from 'react';

import { FeatureFlag as FeatureFlagType } from '../../constants/featureFlags';
import { useClientHasRendered } from '../../helpers/hooks';
import { useFeatureFlags } from '../../helpers/hooks/useFeatureFlags';

interface IProps {
  oldComponent?: React.JSX.Element;
  newComponent?: React.JSX.Element;
  featureFlag: FeatureFlagType;
}

export const FeatureFlag = ({
  featureFlag,
  oldComponent = <></>,
  newComponent = <></>,
}: IProps) => {
  const result = useFeatureFlags([featureFlag]);
  // We stick to running feature flagged content on the client only as static pages in Next don't
  // have access to query strings during initial render and this can cause hydration mismatches.
  const clientHasRendered = useClientHasRendered();

  return clientHasRendered && result[featureFlag] ? newComponent : oldComponent;
};
